<div class="user-preference-settings-container no-select">

  <div class="widget-div">

    @if (canDateFormatBeViewed) {
      <app-shared-widget-container-component class="expanded">
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canDateFormatBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canDateFormatBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Date Format</div>
        </div>
        <div block>
          <div class="form">

            <div class="form-column min-width">
              <div class="form-control-div">
                <div class="label-with-icon">
                  <label for="dateFormat">{{ text.settings.preferenceSettings.dateFormat }}</label>
                  <div class="spacer"></div>
                  <app-display-icon
                    [tooltip]="'Select how dates are displayed throughout the application'"
                    [icon]="icons.infoSlabCircleOutline"
                    [colour]="iconColours.secondary">
                  </app-display-icon>
                </div>
                <app-shared-custom-select
                  id="dateFormat"
                  (selectionChange)="onChangeDateFormatOption($event)"
                  [allowMultiple]="false"
                  [placeholder]="'Select Format...'"
                  [selected]="selectedDateFormat"
                  [setOptions]="dateOptions()"
                  [showChips]="false">
                </app-shared-custom-select>
              </div>
            </div>

          </div>
        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          @if (hasDateFormatBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canDateFormatBeEdited === false"
              (click)="onRevertForm('dateFormat')">
              <app-display-icon
                [colour]="canDateFormatBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canDateFormatBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isDateFormatDisabled"
              (click)="onSubmitForm('dateFormat')">
              <app-display-icon
                [colour]="isDateFormatDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

    @if (canDisplayOrderBeViewed) {
      <app-shared-widget-container-component class="expanded">
        <div title class="widget-div-heading">
          <app-display-icon
            [tooltip]="canDisplayOrderBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
            [icon]="canDisplayOrderBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Store Display Order</div>
        </div>
        <div block>
          <div class="form">

            <div class="form-column min-width">
              <div class="form-control-div">
                <div class="label-with-icon">
                  <label for="displayOrderSelect">Display Order Type</label>
                  <div class="spacer"></div>
                  <app-display-icon
                    [tooltip]="'Choose how stores are ordered in store selection dropdowns'"
                    [icon]="icons.infoSlabCircleOutline"
                    [colour]="iconColours.secondary">
                  </app-display-icon>
                </div>
                <app-shared-custom-select
                  id="displayOrderSelect"
                  (selectionChange)="onChangeDisplayOrderOption($event)"
                  [allowMultiple]="false"
                  [placeholder]="'Select Display Order...'"
                  [selected]="selectedDisplayOrder"
                  [setOptions]="displayOrderOptions()"
                  [keyOrder]="displayOrderKeyOrder()"
                  [showChips]="false">
                </app-shared-custom-select>
              </div>
            </div>

            @if (isCustomOrderMode) {
              <div class="form-column full-width no-top-margin">
                <div class="store-list-container">
                  <div class="store-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
                    @for (store of orderedStores; track store.storeId) {
                      <div class="store-item" cdkDrag>
                        <app-display-icon
                          [icon]="icons.swapVertical"
                          [colour]="iconColours.secondary"
                          [tooltip]="'Drag to reorder'">
                        </app-display-icon>
                        <span class="store-name">{{ store.name }}</span>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }

          </div>
        </div>
        <div actions class="widget-actions" appHorizontalScroll>
          @if (hasDisplayOrderBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canDisplayOrderBeEdited === false"
              (click)="onRevertForm('displayOrder')">
              <app-display-icon
                [colour]="canDisplayOrderBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canDisplayOrderBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isDisplayOrderDisabled"
              (click)="onSubmitForm('displayOrder')">
              <app-display-icon
                [colour]="isDisplayOrderDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  <div class="ups-container-action-bar widget-actions">
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save All
      </button>
  </div>

</div>
